module.exports = __webpack_public_path__ + "img/20220624162459.722c3eea.png";